import Seo from './Seo.js'

export default Seo